import { axiosAzure } from '../interceptors/axios-azure';

const VITE_API_BASE_URL_MEG = import.meta.env.VITE_API_BASE_URL_MEG;
const VITE_GUEST_TOKEN_URL = import.meta.env.VITE_GUEST_TOKEN_URL;

export const httpFetchGuestToken = data => {
  const url = `${VITE_GUEST_TOKEN_URL}`;
  return axiosAzure({ 
    method: 'post', 
    url, 
    data 
  });
};

export const httpPostCreateSession = data => {
  const url = `${VITE_API_BASE_URL_MEG}/session/create`;
  return axiosAzure({ 
    method: 'post', 
    url, 
    data 
  });
};

export const httpGetSession = (sessionToken) => {
  const url = `${VITE_API_BASE_URL_MEG}/session/${sessionToken}`;
  return axiosAzure({ 
    method: 'get', 
    url
  });
};

export const httpGetRetriveTap = (userId) => {
  const url = `${VITE_API_BASE_URL_MEG}/register/${userId}/retrieve-tap`;
  return axiosAzure({ 
    method: 'get', 
    url 
  });
};

export const httpGetCreateOptions = (userId) => {
  const url = `${VITE_API_BASE_URL_MEG}/register/${userId}/create-options`;
  return axiosAzure({ 
    method: 'get', 
    url 
  });
};


export const httpRegisterPassKey = (data, userId) => {
  const url = `${VITE_API_BASE_URL_MEG}/register/${userId}/add-security-key`;
  return axiosAzure({
    method: 'post', 
    url, 
    data 
  });
};

export const httpGetInstructions = () => {
  const url = `${VITE_API_BASE_URL_MEG}/instructions`;
  return axiosAzure({ 
    method: 'get', 
    url
  });
};
